import { useEffect, useState, useMemo, useContext } from 'react';
import useSound from 'use-sound';
import ConfettiExplosion from 'react-confetti-explosion';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import ConfettiCanvas from './WinnerConfetti';

const WinnerPopperComponent = ({ trigger }) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const { setwinnerPopper } = useContext(PropertyContext);

  const audiofile =
    JSON.parse(localStorage.getItem('audiofiles') || '{}')?.Winner ?? '';

  useEffect(() => {
    if (trigger) {
      const playSoundAndShowPopup = async () => {
        try {
          const audioplayer = new Audio(audiofile);
          await audioplayer
            .play()
            .catch((e) => console.error('play failed', e));
          setwinnerPopper(true); // Show popup after sound starts
          setShowConfetti(true);
        } catch (err) {
          console.error('Audio play failed', err);
        }

        const confettiTimer = setTimeout(() => {
          setShowConfetti(false);
          setwinnerPopper(false);
        }, 6000);

        return () => clearTimeout(confettiTimer);
      };

      playSoundAndShowPopup();
    }
  }, [trigger]);

  const confettiConfig = useMemo(
    () => ({
      force: window.innerWidth <= 768 ? 2.5 : 5,
      duration: 10000,
      particleCount: window.innerWidth <= 768 ? 1000 : 2500,
      width: window.innerWidth,
      height: window.innerHeight,
      particleSize: window.innerWidth <= 768 ? 6 : 8,
      zIndex: 9999,
      fadeOut: true,
      colors: [
        '#FFD700',
        '#FF6347',
        '#32CD32',
        '#4169E1',
        '#FF69B4',
        '#8A2BE2',
        '#2184FDCC',
      ],
    }),
    []
  );

  return showConfetti && <ConfettiCanvas />;
};

export default WinnerPopperComponent;
